import React from 'react';
import Layout from '../components/layout';
import SEO from '../components/SEO';
import { graphql, useStaticQuery } from 'gatsby';
import Image from 'gatsby-plugin-sanity-image';
import BlockContent from '@sanity/block-content-to-react';
import Testimonials from '../components/Testimonials';
import { center, left, right } from '../marks/alignment';

const IndexPage = ({ location }) => {
  const { sanityHomepage } = useStaticQuery(graphql`
    query {
      sanityHomepage {
        pageTitle
        _rawContent
        homepageImage {
          ...ImageWithPreview
        }
      }
    }
  `);

  return (
    <Layout location={location}>
      <SEO title="Home" />

      <div className={'flex flex-col md:flex-row justify-between'}>
        <Image
          className={'max-w-full w-full md:w-xl shadow-md border border-gray-800'}
          {...sanityHomepage.homepageImage}
          width={500}
          alt={`Image of people laughing in a comedy venue`}
        />
        <div className={'flex mt-4 md:ml-4 flex-col'}>
          <BlockContent blocks={sanityHomepage._rawContent} serializers={{ marks: { left, center, right } }} />
        </div>
      </div>
      <Testimonials />
    </Layout>
  );
};

export default IndexPage;
